import React, { FC, useEffect, useRef, useState } from 'react';
import { Progress } from 'antd';

interface IComponentProps {}

export const Spinner: FC<IComponentProps> = () => {
  const [percent, setPercent] = useState(0);
  const frameRef = useRef<number>();

  useEffect(() => {
    let lastTime = performance.now();

    const animate = (now: number) => {
      const delta = now - lastTime;
      lastTime = now;

      const speed = 0.03;

      setPercent((prev) => {
        let next = prev + delta * speed;
        if (next >= 100) {
          next = 0;
        }
        return next;
      });

      frameRef.current = requestAnimationFrame(animate);
    };

    frameRef.current = requestAnimationFrame(animate);

    return () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
      }
    };
  }, []);

  return (
    <div className="spinner">
      <Progress type="circle" percent={percent} size={32} strokeWidth={14} strokeLinecap="round" showInfo={false} />
    </div>
  );
};
